import { render, staticRenderFns } from "./cms-rich-text.vue?vue&type=template&id=45a5f994&"
import script from "./cms-rich-text.vue?vue&type=script&lang=js&"
export * from "./cms-rich-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports